import { OrderItem } from "src/app/core/entities/orderItem";

export function getOrderItemFromProduct(
  product: any,
  taxCalc: any,
  tax: any,
  taxValue: number,
  clientId: number,
  quantity: number,
  total: number
): OrderItem {
  const fatorConversao = Number(
    product?.fator_conversao ?? product?.fatorConversao ?? null
  );
  const hasConversao = Number.isFinite(fatorConversao) && fatorConversao > 0;

  let item: OrderItem = {
    cor: product.cor,
    corDescricao: product.corDescricao,
    estampa: product.estampa,
    tamanho: product.tamanho,
    cliente: clientId,
    produto: product.id,
    produtoReferencia: product.referencia,
    nome: product.nome ?? product.imagem,
    imagem: product.imagem ?? product.nome,
    // produtoreferencia: product.referencia,
    produtoDescricao: product.descricao,
    quantidade: quantity,
    ...(hasConversao
      ? {
          quantidade_digitada: Number(
            product?.quantidade_digitada ?? product?.quantidadeDigitada ?? null
          ),
          unidade_digitada: product?.unidade_digitada ?? product?.unidadeDigitada,
          quantidade_convertida: Number(
            product?.quantidade_convertida ??
              product?.quantidadeConvertida ??
              null
          ),
          unidade_convertida:
            product?.unidade_convertida ?? product?.unidadeConvertida,
          fator_conversao: fatorConversao,
          unidade_estoque: product?.unidade_estoque ?? product?.unidadeEstoque,
        }
      : {}),
    ...(Number.isFinite(Number(product?.peso_total_liquido)) &&
    Number(product?.peso_total_liquido) > 0
      ? { peso_total_liquido: Number(product.peso_total_liquido) }
      : {}),
    preco: product.precopromocional ? product.precopromocional : product.preco,
    acrescimo: 0,
    acrescimoPercent: 0,
    desconto: 0,
    descontoPercent: product.desconto,
    total: total,
    imp_estado: tax ? tax.estado : null,
    imp_ipi: tax ? tax.ipi : null,
    imp_alicms: tax ? tax.alicms : null,
    imp_alicmsorigem: tax ? tax.alicmsorigem : null,
    imp_alfcpst: tax ? tax.fcpSt : null,
    imp_substicms: tax ? tax.substicms : null,
    imp_baseipi: taxCalc ? taxCalc.base_ipi : null,
    imp_basesubst: taxCalc ? taxCalc.base_sub : null,
    imp_basefcpst: taxCalc ? taxCalc.base_fcp_st : null,
    imp_valoripi: taxCalc ? taxCalc.valor_ipi : null,
    imp_valorsubst: taxCalc ? taxCalc.valor_sub : null,
    imp_valorfcpst: taxCalc ? taxCalc.valor_fcp_st : null,
    imp_valorimposto: taxValue,
    codigoBarras: null,
  };

  return item;
}
